import React, { Component } from 'react';
import ServiceList from './ServiceList';
import Service from './Service';
import Hidden from 'material-ui/Hidden';
import Grid from 'material-ui/Grid';

import { withRouter } from "react-router-dom";

class Services extends Component {
  state = { selectedService: null };

  render() {
    const service = this.findService(this.props.match.params.service);

    if (!service && this.state.selectedService !== null) {this.setState({selectedService:null})};
    if (service && this.state.selectedService !== service) {this.setState({selectedService:service})};

    return (
      <Grid container>
        <Grid item xs={12} sm={12} md={4} lg={3} >
          <ServiceList
            services={this.props.services}
            selectService={this.selectService}
            selectedService={this.state.selectedService}
          />
        </Grid>
        <Hidden smDown>
          <Service service={this.state.selectedService || this.props.services[0]} className='selectedService' />
        </Hidden>
      </Grid>
    )
  }

  selectService = id => {
    const service = this.props.services.find(service => service.id === id);

    if (this.state.selectedService === service) {
      // this.setState({ selectedService: null });
      this.props.history.push(`/usluge`);
      return
    }
    // this.setState({ selectedService: service });
    this.props.history.push(`/usluge/${service.id}`);
  }

  findService = id => {
    const services = this.props.services;
    return services.find(service => service.id === id);
  }
}

export default withRouter(Services);



// WEBPACK FOOTER //
// ./src/components/Services.js